"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var payment_1 = require("../../../../common/constants/payment");
var TransactionErrorTypes_1 = require("../../../../common/enum/TransactionErrorTypes");
var UrlParamTypes_1 = require("../../../../common/enum/UrlParamTypes");
exports.useMercadoPago = function (goToNextStep, deal, loading) {
    var _a;
    var token = (_a = deal) === null || _a === void 0 ? void 0 : _a.uuid;
    var _b = react_1.useState(false), checkTransaction = _b[0], setCheckTransaction = _b[1];
    var _c = react_1.useState(null), getUrlResponse = _c[0], setUrlResponse = _c[1];
    var _d = react_1.useState(false), isFailed = _d[0], setIsFailed = _d[1];
    var _e = react_1.useState(null), paymentId = _e[0], setPaymentId = _e[1];
    var getIframeUrl = function () {
        if (paymentId) {
            return payment_1.PAYMENT_CONFIG.dxpWidgetUrlWeb + "?" + UrlParamTypes_1.UrlParamTypes.PAYMENT_ID + "=" + paymentId;
        }
        return payment_1.PAYMENT_CONFIG.dxpWidgetUrlWeb + "?" + UrlParamTypes_1.UrlParamTypes.TOKEN + "=" + token;
    };
    var getFirstElementPaymentId = function (paymentInfo) {
        var transactionId = paymentInfo.reduce(function (previous, data) {
            if (new Date(data.transactionTime).getTime() > new Date(previous.transactionTime).getTime()) {
                previous.transactionId = data.transactionId;
                previous.transactionTime = data.transactionTime;
            }
            return previous;
        }, {
            transactionTime: Number.MIN_VALUE,
            transactionId: null,
        }).transactionId;
        return transactionId;
    };
    var onMessage = function (message) {
        var _a;
        var _b = (_a = message) === null || _a === void 0 ? void 0 : _a.data, urlResponseMP = _b.urlResponseMP, isTransactionComplete = _b.isTransactionComplete, isErrorTransaction = _b.isErrorTransaction;
        if (urlResponseMP) {
            setCheckTransaction(isTransactionComplete);
            setUrlResponse(urlResponseMP);
            setIsFailed(isErrorTransaction);
        }
    };
    react_1.useEffect(function () {
        var _a, _b;
        var status = (_a = deal) === null || _a === void 0 ? void 0 : _a.status;
        var paymentInfo = (_b = deal) === null || _b === void 0 ? void 0 : _b.paymentInfo;
        var transactionId;
        if (paymentInfo) {
            transactionId = getFirstElementPaymentId(paymentInfo);
        }
        if (status === TransactionErrorTypes_1.TransactionErrorTypes.AUTHORIZED) {
            goToNextStep();
            return;
        }
        if (transactionId && status !== TransactionErrorTypes_1.TransactionErrorTypes.COMPONENT_INIT) {
            setPaymentId(transactionId);
            return;
        }
        if (status === TransactionErrorTypes_1.TransactionErrorTypes.FAILED) {
            setIsFailed(true);
            return;
        }
    }, [deal, loading]);
    react_1.useEffect(function () {
        if (checkTransaction && getUrlResponse) {
            window.top.location = getUrlResponse;
        }
    }, [getUrlResponse, checkTransaction]);
    react_1.useEffect(function () {
        window.addEventListener('message', onMessage);
        return function () {
            window.removeEventListener('message', onMessage);
        };
    }, []);
    return { isFailed: isFailed, paymentId: paymentId, getIframeUrl: getIframeUrl };
};
